import React, { Component } from "react";
import { connect } from "react-redux";
import { goBack } from "react-router-redux";
import { breadcrumbs } from "../../../../actions/appActions";
import loginInfo from "../../components/LoginInfo";
import AuditHistoryView from "../../components/AuditHistoryView";
import OfficialHistoryDetailGrid from "../../components/grids/OfficialHistoryDetailGrid";
import { DICTIONARY_HISTORY_ACTIONS } from "../../components/audit/entityLabels";
import Button from "../../../../components/form/Button";
import { styles } from "../../index";

class DictionaryHistoryPage extends Component {
  componentDidMount() {
    const { auth, dictionary } = this.props;
    this.props.breadcrumbs([
      { label: "Číselníky", path: `${auth.startUrl}/ciselniky` },
      { label: dictionary.h1, path: `${auth.startUrl}/ciselniky/${dictionary.name}` },
      { label: "Historie" },
    ]);
  }

  render() {
    const { auth, dictionary } = this.props;
    return (
      <div>
        <AuditHistoryView
          auth={auth}
          grid={OfficialHistoryDetailGrid}
          gridName={`dictionaryHist_${dictionary.name}`}
          url={`${dictionary.url}/historie`}
          showOwner={false}
          showEntity={true}
          allowedActions={DICTIONARY_HISTORY_ACTIONS}
        />
        <div style={{ marginTop: 12 }}>
          <Button
            type="button"
            style={styles.buttons}
            label="Zpět"
            onClick={() => this.props.goBack()}
          />
        </div>
      </div>
    );
  }
}

export default connect(null, { breadcrumbs, goBack })(loginInfo(DictionaryHistoryPage));
